import React, { useState, useEffect, useRef } from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import Headroom from "react-headroom"
import { LayoutWrapper } from "../common/wrappers/Wrappers"
import { breakpoint, color, transition, opacity } from "../../configs/utilities"
import { gsap } from "gsap"
import { ClickOutside } from "../../configs/clickOutside"
import NavItemsDesktop from "./navbar/NavItemsDesktop"
import NavItemsMobile from "./navbar/NavItemsMobile"
import NavbarHamburger from "./navbar/NavbarHamburger"
import logo from "../../assets/navbar/logo.svg"
import getGlobalDocument from "../../configs/getGlobalDocument"
import facebook from "../../assets/navbar/facebook.svg"
import instagram from "../../assets/navbar/instagram.svg"
import linkedin from "../../assets/navbar/linkedin.svg"
import twitter from "../../assets/navbar/twitter.svg"
import ButtonLink from "../common/buttons/ButtonLink"

const Navbar = () => {
  const data = useStaticQuery(graphql`
    {
      allPagesJson {
        edges {
          node {
            path
            text
            isSubmenu
            submenu {
              path
              text
            }
          }
        }
      }
    }
  `)

  const [isOpen, navbarSwitch] = useState(false)

  let mobileMenu = useRef(null)
  let widthOn = `-80vw`
  let widthOff = `0vw`

  const toggleNav = () => {
    navbarSwitch(isOpen => !isOpen)
    navbarMenuOnOff()
  }

  const navbarMenuOnOff = () => {
    let overlay = getGlobalDocument().getElementsByClassName("overlay")

    if (!isOpen) {
      gsap.to(mobileMenu.current, { duration: 0.2, x: widthOn, opacity: 1 })
      gsap.to(overlay, { duration: 0.1, opacity: 1, display: "block" })
    } else {
      gsap.to(mobileMenu.current, { duration: 0.2, x: widthOff, opacity: 0 })
      gsap.to(overlay, { duration: 0.1, opacity: 0, display: "none" })
    }
  }

  const clickOutsideHandler = () => {
    let overlay = getGlobalDocument().getElementsByClassName("overlay")

    if (isOpen) {
      gsap.to(mobileMenu.current, { duration: 0.2, x: widthOff })
      gsap.to(overlay, { duration: 0, opacity: 0, display: "none" })
      navbarSwitch(!isOpen)
    }
  }

  ClickOutside(mobileMenu, clickOutsideHandler, "navbarBurger")

  useEffect(() => {
    let documentStyle = getGlobalDocument().getElementsByTagName("html")[0]

    isOpen
      ? (documentStyle.style.overflow = "hidden")
      : (documentStyle.style.overflow = "auto")
  }, [isOpen])

  return (
    <Headroom>
      <Wrapper>
        <LayoutWrapper>
          <Content>
            <Logo
              onClick={isOpen ? toggleNav : null}
              className={isOpen ? `hidden` : ``}
            >
              <Link to="/">
                <img src={logo} alt="Logo" />
              </Link>
            </Logo>
            <DesktopContentWrapper>
              <DesktopLinks>
                <NavItemsDesktop data={data.allPagesJson.edges} />
              </DesktopLinks>
              <AddMoverWrapper>
                <ButtonLink
                  to="/contact-add-mover"
                  buttonText="Add mover"
                  buttonBackground={color.yellow}
                  buttonTextColor={color.blue}
                />
              </AddMoverWrapper>
              <SocialNetworks>
                <a
                  href="https://www.facebook.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebook} alt="facebook" />
                </a>
                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagram} alt="instagram" />
                </a>
                <a
                  href="https://www.linkedin.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={linkedin} alt="linkedin" />
                </a>
                <a
                  href="https://twitter.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitter} alt="twitter" />
                </a>
              </SocialNetworks>
            </DesktopContentWrapper>
            <NavbarHamburger toggleNav={toggleNav} isOpen={isOpen} />
            <MobileWrapper ref={mobileMenu}>
              <NavItemsMobile isOpen={isOpen} data={data.allPagesJson.edges} />
            </MobileWrapper>
          </Content>
        </LayoutWrapper>
      </Wrapper>
    </Headroom>
  )
}

export default Navbar

const Wrapper = styled.div`
  width: 100%;
  color: ${color.black};
`

const Content = styled.div`
  width: 100%;
  min-height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (min-width: ${breakpoint.xl}) {
    min-height: 100px;
    align-items: flex-end;
    padding-bottom: 10px;
  }
  .hidden {
    display: none;
  }
`

const Logo = styled.div`
  img {
    width: 100%;
    max-width: 200px;
  }
  transition: ${transition.default};

  @media screen and (min-width: ${breakpoint.xl}) {
    &:hover {
      opacity: ${opacity.default};
    }
  }
`

const DesktopContentWrapper = styled.div`
  width: 90%;
  display: flex;
  justify-content: flex-end;
  column-gap: 40px;
`

const DesktopLinks = styled.div``

const AddMoverWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${breakpoint.xl}) {
    display: flex;
    align-self: center;
  }
`

const SocialNetworks = styled.div`
  display: none;
  @media screen and (min-width: ${breakpoint.xl}) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    column-gap: 20px;
    img {
      width: 18px;
      opacity: 0.7;
      transition: ${transition.default};

      &:hover {
        opacity: 1;
      }
    }
  }
`

const MobileWrapper = styled.div`
  position: absolute;
  top: 65px;
  right: -100%;
  width: 100%;
  height: 90vh;
  padding: 50px 0;
  background: ${color.white};
  transform: ${transition.default};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow-y: auto;

  @media screen and (min-width: ${breakpoint.xl}) {
    top: 85px;
  }
`
